import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Col, Row } from 'react-bootstrap';


const propTypes = exact({
  leftSize: PropTypes.number.isRequired,
  leftRender: PropTypes.func.isRequired,
  leftStyle: PropTypes.object,
  rightSize: PropTypes.number.isRequired,
  rightRender: PropTypes.func.isRequired,
  rightStyle: PropTypes.object,
});


const SplitLayout = (props) => {
  const {
    leftSize,
    leftRender,
    leftStyle,
    rightSize,
    rightRender,
    rightStyle,
  } = props;

  return (
    <Row>
      <Col style={leftStyle} xs={leftSize}>
        {leftRender()}
      </Col>
      <Col style={rightStyle} xs={rightSize}>
        {rightRender()}
      </Col>
    </Row>
  );
};


SplitLayout.propTypes = propTypes;

SplitLayout.defaultProps = {
  leftStyle: { paddingRight: '0px' },
  rightStyle: { paddingLeft: '10px' },
};


export default SplitLayout;
